import {
  AutoRefreshTokenService,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  UserActivityService,
  createInterceptorCondition,
  provideKeycloak,
  withAutoRefreshToken,
} from 'keycloak-angular';

import { AppEnvironment } from '@f4rm/app-core/models/app-environment';

/**
 * Determines the Keycloak onLoad strategy based on current URL path.
 * Exception pages should not trigger Keycloak redirect.
 */
function getKeycloakOnLoadStrategy(): 'login-required' | undefined {
  const currentPath = window.location.pathname;
  const isExceptionPage = currentPath.startsWith('/exception');

  if (isExceptionPage) {
    console.log('[Keycloak] Skipping auto-login for exception page:', currentPath);
    return undefined;
  }

  return 'login-required';
}

export const provideKeycloakAngular = (environment: AppEnvironment) => {
  const autoRefreshConfig = {
    sessionTimeout: 300000,
    onInactivityTimeout: 'logout' as const,
  };

  const onLoadStrategy = getKeycloakOnLoadStrategy();

  return provideKeycloak({
    config: environment.config.keycloak,
    initOptions: {
      onLoad: onLoadStrategy,
      pkceMethod: 'S256',
      scope: environment.config.keycloak.scope,
      checkLoginIframe: false,
      enableLogging: !environment.production,
    },
    features: [
      withAutoRefreshToken(autoRefreshConfig),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [
          createInterceptorCondition<IncludeBearerTokenCondition>({
            urlPattern: new RegExp(`^(${environment.config.keycloak.resourceServerUrls
              .join('|')})(/.*)?$`, 'i'),
          }),
        ],
      },
    ],
  });
};
